import { useState } from "react";
import Swal from "sweetalert2";
import invoiceService from "../services/invoiceService";
import { descargarJsonInvalidacion, getFilenameFromPath, getInvalidacionPath } from "../components/utils/invoiceValidation";

/**
 * Hook personalizado para manejar la visualización de invalidaciones
 */
export const useInvalidacion = () => {
  const [showInvalidacionModal, setShowInvalidacionModal] = useState(false);
  const [selectedInvoice, setSelectedInvoice] = useState(null);
  const [selectedInvalidacion, setSelectedInvalidacion] = useState(null);
  const [loadingInvalidacion, setLoadingInvalidacion] = useState(false);
  const [isDownloading, setIsDownloading] = useState(false);

  /**
   * Abre el modal y carga los datos de invalidación
   */
  const handleVerInvalidacion = async (invoice) => {
    setSelectedInvoice(invoice);
    setLoadingInvalidacion(true);
    setShowInvalidacionModal(true);

    try {
      const data = await invoiceService.getInvalidacion(invoice.id);
      setSelectedInvalidacion(data);
    } catch (error) {
      console.error("Error al cargar invalidación:", error);
      Swal.fire("Error", "No se pudo cargar la información de anulación", "error");
      setShowInvalidacionModal(false);
    } finally {
      setLoadingInvalidacion(false);
    }
  };

  /**
   * Cierra el modal de invalidación
   */
  const handleCloseInvalidacionModal = () => {
    setShowInvalidacionModal(false);
    setSelectedInvoice(null);
    setSelectedInvalidacion(null);
  };

  /**
   * 🆕 Descarga el JSON de invalidación
   * 🔧 CORREGIDO - Ahora obtiene la ruta desde selectedInvalidacion
   */
  const handleDescargarInvalidacion = async (invoice) => {
    // Usar la invalidación del estado si está disponible, sino la del invoice
    const invalidacionPath = selectedInvalidacion?.json_invalidacion_path || 
                            getInvalidacionPath(invoice);

    if (!invalidacionPath) {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Esta factura no tiene archivo de invalidación disponible'
      });
      return;
    }

    setIsDownloading(true);

    try {
      const filename = getFilenameFromPath(invalidacionPath);
      await descargarJsonInvalidacion(filename);
      
      Swal.fire({
        icon: 'success',
        title: '¡Descarga exitosa!',
        text: 'El archivo de invalidación se ha descargado correctamente',
        timer: 2000,
        showConfirmButton: false
      });

    } catch (error) {
      console.error('Error en descarga:', error);
      Swal.fire({
        icon: 'error',
        title: 'Error al descargar',
        text: error.message || 'No se pudo descargar el archivo de invalidación'
      });
    } finally {
      setIsDownloading(false);
    }
  };

  return {
    // Estado
    showInvalidacionModal,
    selectedInvoice,
    selectedInvalidacion,
    loadingInvalidacion,
    isDownloading,
    
    // Funciones
    handleVerInvalidacion,
    handleCloseInvalidacionModal,
    handleDescargarInvalidacion,
  };
};